import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip} from "reactstrap";
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import {connect} from "react-redux";
import {updateBan} from './../../actions';
import BanForm from "../BanForm";

class BanEditAction extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      modal: false,
      loading: false,
      errors: {}
    };

    this.updateBan = this.updateBan.bind(this);
    this.banForm = React.createRef();
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]})
  }

  updateBan(e, data) {
    e.preventDefault();
    this.setState({loading: true, errors: {}});

    this.props.updateBan({
      ...data,
      id: this.props.user.ban.id,
    }).then(() => {
      this.props.handleChange();
      this.setState({
        loading: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        loading: false,
        errors: e.response.data.form.errors
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <span id={'banEditUser-' + this.props.user.id} className="fas fa-user-lock mr-2 pointer" onClick={() => this.toggle('modal')}/>
        <Tooltip
          delay={0}
          placement="bottom"
          isOpen={this.state.tooltip}
          target={'banEditUser-' + this.props.user.id}
          toggle={() => this.toggle('tooltip')}
        >
          <FormattedMessage id="admin.respondents.banEditAction.tooltip" />
        </Tooltip>

        <Modal isOpen={this.state.modal} size="lg" toggle={() => this.toggle('modal')}>
          <ModalHeader toggle={() => this.toggle('modal')} tag="h2"><FormattedMessage id="admin.respondents.banEditAction.modalHeader"/></ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <BanForm categories={[1,2,3,4,5,6,7]} errors={this.state.errors} ref={this.banForm} ban={this.props.user.ban}/>
          </ModalBody>
          <ModalFooter>
            <div className="direction-group d-flex justify-content-end">
              <div className="direction-right">
                <FormattedMessage id="_.button.save">{
                  (message) => <LaddaButton
                    className="btn btn-success btn-ladda mb-0 ml-3"
                    data-style={ZOOM_OUT}
                    onClick={e => this.updateBan(e, this.banForm.current.state)}
                    loading={this.state.loading}
                  >
                    {message}
                  </LaddaButton>
                }</FormattedMessage>
                <FormattedMessage id="_.button.cancel">{
                  (message) => <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggle('modal')}>{message}</Button>
                }</FormattedMessage>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

BanEditAction.propTypes = {
  user: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect(null, { updateBan })(BanEditAction);